import i18n from "@/i18n";

export const postTypesFields = [
    {
        key: "text",
        label: i18n.t("posts.types")
    },
    {
        key: "style",
        label: i18n.t("style.title")
    }
];
